import {useContext} from 'react'

import PropTypes from 'prop-types'

import Button, {atomButtonDesigns} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMediaQuery} from '@s-ui/react-hooks'
import {useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import ListRelatedAds, {listRelatedAdsDisplay} from '@adv-mt/mt-list-related-ads'
import MediaVideo from '@adv-mt/mt-media-video'

import {NEWS_DETAIL_BASE_CLASS} from '../config.js'

const FIRST_VIDEO_INDEX = 0
const MAX_VEHICLES_TO_SHOW_DESKTOP = 4
const MAX_VEHICLES_TO_SHOW_MOBILE = 8

export const MediaVideoWrapper = ({entryInfo, professionalSellerAds, professionalSellerAdsListingUrl, vehicles}) => {
  const {i18n} = useContext(Context)
  const {index} = entryInfo
  const isHigherThanMobileResolution = useMediaQuery(useMediaQueryBreakpoints.sm)
  const numberOfItemsToShow = isHigherThanMobileResolution ? MAX_VEHICLES_TO_SHOW_DESKTOP : MAX_VEHICLES_TO_SHOW_MOBILE

  return (
    <div className={`${NEWS_DETAIL_BASE_CLASS}-mediaVideoWrapper`}>
      <MediaVideo {...entryInfo} placeholderImageSrc={entryInfo.thumbnailMaxRes} preventIframeLoad />
      {professionalSellerAds.length && index === FIRST_VIDEO_INDEX ? (
        <ListRelatedAds
          ads={professionalSellerAds}
          display={isHigherThanMobileResolution ? listRelatedAdsDisplay.grid : listRelatedAdsDisplay.scrolling}
          itemsPerRow={numberOfItemsToShow}
          link={
            <Button design={atomButtonDesigns.LINK} href={professionalSellerAdsListingUrl} link>
              {i18n.t('COMMON.SEE_MORE_ADS')}
            </Button>
          }
          maxItems={numberOfItemsToShow}
          title={i18n.t('NEWS.DETAIL_PROFESSIONAL_ADS_TITLE', {
            make: vehicles[0].make.name,
            model: vehicles[0].model ? vehicles[0].model.name : ''
          })}
        />
      ) : null}
    </div>
  )
}

MediaVideoWrapper.propTypes = {
  entryInfo: PropTypes.object,
  professionalSellerAds: PropTypes.array,
  professionalSellerAdsListingUrl: PropTypes.string,
  vehicles: PropTypes.array
}
